import { render, staticRenderFns } from "./ContractIndex.vue?vue&type=template&id=229f100f&scoped=true"
import script from "./ContractIndex.vue?vue&type=script&lang=js"
export * from "./ContractIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f100f",
  null
  
)

export default component.exports